import { array, struct } from 'io-ts/Decoder';

import { EqualsType } from '../../api/generic/search/filter';
import { CountryCode } from '../../country';

export const Country = struct({
	equalsType: EqualsType,
	values: array(CountryCode),
});
